// Helper function to get config from runtime (window.ENV) or build-time (process.env)
const getConfig = (key) => {
  // Try window.ENV first (runtime config from Azure)
  if (
    window.ENV &&
    window.ENV[key] &&
    window.ENV[key] !== `\${REACT_APP_${key}}`
  ) {
    return window.ENV[key];
  }
  // Fallback to build-time environment variable
  return process.env[`REACT_APP_${key}`] || "";
};

// Whitelist of approved user emails
const APPROVED_USERS = getConfig("APPROVED_USERS")
  ? getConfig("APPROVED_USERS")
      .split(",")
      .map((email) => email.trim())
  : [
      "i-zaamdur@zekelman.com",
      // Fallback list
    ];

// Check if user email is in the whitelist
export const isUserAuthorized = (userEmail) => {
  console.log("=== isUserAuthorized called ===");
  console.log("Input userEmail:", userEmail);
  console.log("APPROVED_USERS list:", APPROVED_USERS);

  if (!userEmail) {
    console.log("No userEmail provided - returning false");
    return false;
  }

  const normalizedEmail = userEmail.toLowerCase().trim();
  console.log("Normalized email:", normalizedEmail);

  const isApproved = APPROVED_USERS.some((approvedEmail) => {
    const normalizedApproved = approvedEmail.toLowerCase();
    const matches = normalizedApproved === normalizedEmail;
    console.log(
      `Comparing "${normalizedEmail}" with "${normalizedApproved}": ${matches}`,
    );
    return matches;
  });

  console.log("Final authorization result:", isApproved);
  return isApproved;
};

// Get all approved users (for admin purposes)
export const getApprovedUsers = () => {
  return [...APPROVED_USERS];
};

// Optional: Check by domain (if you want to allow all @zekelman.com)
export const isUserDomainAuthorized = (userEmail) => {
  console.log("=== isUserDomainAuthorized called ===");
  console.log("Input userEmail:", userEmail);

  if (!userEmail) {
    console.log("No userEmail provided - returning false");
    return false;
  }

  const domain = userEmail.split("@")[1]?.toLowerCase();
  console.log("Extracted domain:", domain);

  const approvedDomains = ["zekelman.com", "zekelamanindustries.com"];
  console.log("Approved domains:", approvedDomains);

  const isDomainApproved = approvedDomains.includes(domain);
  console.log("Domain authorization result:", isDomainApproved);

  return isDomainApproved;
};
